/*
Lalitha 12/28/2022 3075154998 Add new Component SelectField
Sohel 01/09/2023 3075154998 removed handleNext props
Sohel 01/09/2023 2698959212 pass Type in Selected fields
dilip 01/13/2023 2698959212 Fixed Mapped Selected Fields
dilip 01/16/2023 2698959212 Added handleDirty functionality
dilip 01/16/2023 2698959212 Added GET data API call after map fields save.
sai krishna 01/16/2023 2698959212 add code and description ,type
Sohel 01/16/2023 2698959212 Fixed Download Configuration Toast issue
 dilip 01/20/2023 2698959212 Added Last Step functionality
 Ashraf 01/31/2023 2698959212 Added Sort fields
 Ravi 01/31/2023 2698959212 fixed unsaved popup issue
 Ashraf 02/06/2023 2698959212 fixed sort fields duplicate issue
Sohel 02/07/2023 2698959212 fixed fieldType populate issue
Raghu 02/23/2023 2698959212 fixed new Ui changes
Akhila 06/12/2023 2698959212 added role access
Ravi 06/19/2023 2698959212 Added Breadcrum in data cal and map fields
Sohel 06/19/2023 3075154998 Enable Save Button
Ravi 06/19/2023 2698959212 Added Breadcrum in popup
Ravi 06/23/2023 2698959212 fixed submit issue
*/
import React, { useState, useEffect, useRef } from 'react';
import { Button, Tooltip } from '@material-ui/core';
import reusableInputStyles from '../../../components/InputStyles';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import DialogBox from '../../../components/DialogBox/index';
import FieldsTable from './FieldsTable';
import { useSelector, useDispatch } from 'react-redux';
import PageLoader from '../../../components/PageLoader';
import SearchFields from '../../FrameWorks/GlobalFields/DataRepositories/SearchDataRepositories/index';
import { ErrorSnackbar, SuccessSnackbar } from '../../../components/CustomSnackBar';
import {
  fetchSelectedFieldsData,
  postSelectField,
  resetMsgAndStatus,
  resetBasicInfo,
} from '../../../redux/reducers/EDI';

import BreadCrums from '../../../util/BreadCrum';
import { submissionStart } from '../../../redux/reducers/CommonActions/commonActions';

const DMFieldSelect = ({
  handleBack,
  handleNext,
  exportManager,
  handleDirty,
  editExisting,
  DataManagerAccess,
}) => {
  const classes = reusableInputStyles();
  const [open, setOpen] = useState(false);
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const deletedSelectedFields = useRef([]);

  const saveRef = useRef(false);
  const dispatch = useDispatch();
  const {
    isSelectFieldLoading,
    SelectFieldSuccessMsg,
    SelectFieldErrorMsg,
    SelectFieldStatus,
    dmCode,
    selectedProcessorFields,
    basicInfoData,
    basicInfoSuccessMsg,
    isBasicInfoLoading,
    basicInfoErrorMsg,
  } = useSelector(({ ediExport }) => ediExport);

  const { enabledSubmission } = useSelector(({ commonActions }) => commonActions);

  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (basicInfoSuccessMsg || basicInfoErrorMsg) {
      setTimeout(() => {
        dispatch(resetBasicInfo());
      }, 1500);
    }
  }, [basicInfoErrorMsg, basicInfoSuccessMsg]);

  const type = exportManager ? 'ediExport' : 'ediImport';
  const handleSubmit = () => {
    // if (dmCode) {
    dispatch(submissionStart());
    const selectedProcessorFields =
      selectedRows?.length > 0
        ? selectedRows?.map((el) => {
          return {
            category: el?.category,
            fieldName: el?.fieldName,
            fieldType: el?.fieldType,
            dataManagerCode: dmCode,
            dataManagerRecordId: el?.dataManagerRecordId ? el?.dataManagerRecordId : 0,
            repositoryName: el?.repositoryName,
            dataType: el?.dataType,
          };
        })
        : [];

    const payload = {
      deleteDmRecordFieldIds: [...new Set(deletedSelectedFields.current)],
      dataManagerSelectedFieldRequest: selectedProcessorFields,
      dataManagerCode: dmCode,
      tabType: type,
      // lastStep: saveRef.current ? 2 : 3,
      // dataManagerSortedFieldsRequest: sortedFields,
    };
    dispatch(postSelectField(payload));
    // }
  };

  useEffect(() => {
    if (SelectFieldErrorMsg || SelectFieldSuccessMsg) {
      setTimeout(() => {
        if (SelectFieldSuccessMsg && SelectFieldStatus === 200 && !saveRef.current) {
          handleNext && handleNext();
        }
        dispatch(resetMsgAndStatus());
      }, 1500);
    }
  }, [SelectFieldErrorMsg, SelectFieldSuccessMsg]);

  useEffect(() => dispatch(resetMsgAndStatus()), []);

  useEffect(() => {
    if (basicInfoData?.exportCode) {
      dispatch(fetchSelectedFieldsData(dmCode, type));
    }
  }, [basicInfoData]);

  useEffect(() => {
    if (dmCode && SelectFieldStatus === 200 && saveRef.current) {
      dispatch(fetchSelectedFieldsData(dmCode, type));
    }
  }, [SelectFieldStatus]);

  useEffect(() => {
    const rows = [];
    selectedProcessorFields?.dMSortFieldList?.map((i) => {
      rows?.push({
        ...i,
        fieldName: i?.fieldCode,
        sortOrder: i?.descending,
        printTotal: i?.subtotal,
        tableData: { tableData: i?.tableData, checked: true },
      });
    });
  }, [selectedProcessorFields?.dMSortFieldList]);
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);

  useEffect(() => {
    if (selectedProcessorFields?.dMRecordEntityList?.length > 0) {
      const fields = selectedProcessorFields?.dMRecordEntityList?.map((el) => {
        return {
          category: el?.category,
          fieldName: el?.fieldName,
          fieldType: el?.fieldType,
          isActive: el?.isActive,
          dataManagerCode: dmCode,
          dataManagerRecordId: el?.dataManagerRecordId ? el?.dataManagerRecordId : 0,
          repositoryName: el?.repositoryName,
          dataType: el?.dataType,
          type: el?.type,
          processorFieldType: el?.fieldType,
        };
      });

      // Remove duplicate fields
      const uniqueArray = fields.filter(
        (value, index, self) =>
          index ===
          self.findIndex(
            (t) => t.repositoryName === value.repositoryName && t.fieldName === value.fieldName,
          ),
      );

      setSelectedRows(uniqueArray);
    }
  }, [selectedProcessorFields?.dMRecordEntityList]);
  return (
    <>
      <div>
        <BreadCrums
          name={exportManager ? 'Export Code' : 'Import Code'}
          code={basicInfoData?.exportCode}
          description={exportManager ? 'Export Description' : 'Import Description'}
          descriptionValue={basicInfoData?.exportDescription}
        />
      </div>
      <div className="table-header table-card-header justify-content-end new-standard-textfields">
        <Button
          variant="outlined"
          className={`search-btn ${classes.buttonRoot}`}
          onClick={() => setOpen(true)}
          startIcon={<AccountTreeIcon />}
        >
          Map Fields
        </Button>
      </div>
      <FieldsTable
        setSelectedRows={setSelectedRows}
        selectedRows={selectedRows}
        deletedSelectedFields={deletedSelectedFields}
        exportManager={exportManager}
        handleDirty={handleDirty}
        DataManagerAccess={DataManagerAccess}
        editExisting={editExisting}
      />
      <DialogBox
        open={open}
        dialogClose={handleClose}
        // title="Search Repository Fields"
        title={
          <div className="dialog-breadcrum">
            <p className="dialoge-title-breadcrum">
              <b>Search Repository Fields</b>
            </p>
            <BreadCrums
              name={'Export Code'}
              code={basicInfoData?.exportCode}
              description={'Export Description'}
              descriptionValue={basicInfoData?.exportDescription}
            />
          </div>
        }
        maxWidth="xl"
      >
        <SearchFields
          setSelectedRows={setSelectedRows}
          selectedRows={selectedRows}
          setTempSelectedRows={setTempSelectedRows}
          tempSelectedRows={tempSelectedRows}
          isReports={true}
          mapFields={true}
          isDMTrue={true}
          handleClose={handleClose}
          deletedSelectedFields={deletedSelectedFields}
          dmRecordCategory={{
            categoryCode: 'CO',
            categoryName: 'Core',
          }}
          handleDirty={handleDirty}
        />
      </DialogBox>

      <div className="d-flex justify-content-center mt-3 new-standard-textfields">
        <Button
          variant="outlined"
          onClick={() => {
            handleBack();
          }}
          className={`reset-btn mr-1 ${classes.buttonRoot}`}
        >
          Back
        </Button>
        {/* {basicInfoData?.isDraft === "N" && ( */}
        <Tooltip title={selectedRows?.length === 0 ? `Please add at least one Field` : ''}>
          <span>
            <Button
              variant="outlined"
              type="button"
              className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
              disabled={selectedRows?.length === 0 || enabledSubmission}
              onClick={() => {
                saveRef.current = true;
                handleDirty && handleDirty(false, 'fixed');
                handleSubmit();
              }}
            >
              Save
            </Button>
          </span>
        </Tooltip>
        {/* )} */}
        <Tooltip title={selectedRows?.length === 0 ? `Please add at least one Field` : ''}>
          <span>
            <Button
              variant="outlined"
              disabled={selectedRows?.length === 0 || enabledSubmission}
              onClick={() => {
                saveRef.current = false;
                handleSubmit();
              }}
              className={`search-btn ml-1 ${classes.buttonRoot}`}
            >
              Save & Next
            </Button>
          </span>
        </Tooltip>
      </div>

      {(isSelectFieldLoading || isBasicInfoLoading) && <PageLoader />}
      {(SelectFieldErrorMsg || basicInfoErrorMsg) && (
        <ErrorSnackbar errorMsg={SelectFieldErrorMsg || basicInfoErrorMsg} />
      )}
      {(SelectFieldSuccessMsg || basicInfoSuccessMsg) && (
        <SuccessSnackbar successMsg={SelectFieldSuccessMsg || basicInfoSuccessMsg} />
      )}
    </>
  );
};

export default DMFieldSelect;
